export default __webpack_public_path__ + "static/media/Image1.663cddf8.jpg";